var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.084 11.74H2.44c-.795 0-1.44-.622-1.44-1.39 0-.768.645-1.39 1.44-1.39h11.644l-4.022-3.886a1.358 1.358 0 0 1 0-1.967 1.476 1.476 0 0 1 2.036 0l6.48 6.26a1.358 1.358 0 0 1 0 1.966l-6.48 6.26a1.476 1.476 0 0 1-2.036 0 1.358 1.358 0 0 1 0-1.967l4.022-3.885z", fill: "#9A660A" })
  );
});